const shortUrl = process.env.NEXT_PUBLIC_DOMAIN_SHORT ? `https://${process.env.NEXT_PUBLIC_DOMAIN_SHORT}` : "https://s.id";

export default shortUrl;
